import { DashboardContainer } from '@components/Dashboard';
export default DashboardContainer;
